import { LiveState } from '../types';
import { ReduxState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {LiveState} The Competition Nav Live state.
 */
export const liveSelector = (state) => state.competitionNav.nav.live;
